import { render, staticRenderFns } from "./couponEAdd.vue?vue&type=template&id=5e3b52eb&scoped=true"
import script from "./couponEAdd.vue?vue&type=script&lang=js"
export * from "./couponEAdd.vue?vue&type=script&lang=js"
import style0 from "./couponEAdd.vue?vue&type=style&index=0&id=5e3b52eb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3b52eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e3b52eb')) {
      api.createRecord('5e3b52eb', component.options)
    } else {
      api.reload('5e3b52eb', component.options)
    }
    module.hot.accept("./couponEAdd.vue?vue&type=template&id=5e3b52eb&scoped=true", function () {
      api.rerender('5e3b52eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/couponExpand/couponEAdd.vue"
export default component.exports